import { ActionsUnion, createAction } from 'spw-redux/types';
import { Address, GetProjectsParams, IProject } from '../projects/types';
import {
  BenchmarkReportSummary,
  BenchmarkProject,
  BenchmarkReport,
  GetBenchmarkReportsParams,
  PaginatedBenchmarkReports,
  BenchmarkReportEditor,
  MissingProjectData,
  BenchmarkReportCategory,
  BenchmarkReportIcon,
  BenchmarkReportIconsMap,
  BenchmarkReportCategoriesMap,
  DismissedIssuesMap,
  MissingData,
  MissingFloorDataField,
} from './types';
import { ClientListItemVM } from '../clients/types';

export const GET_BENCHMARK_PROJECTS =
  'benchmarkReports/GET_BENCHMARK_PROJECTS ';
export const GET_BENCHMARK_PROJECTS_SUCCEEDED =
  'benchmarkReports/GET_BENCHMARK_PROJECTS_SUCCEEDED';
export const GET_BENCHMARK_PROJECTS_FAILED =
  'benchmarkReports/GET_BENCHMARK_PROJECTS_FAILED';

export const SET_SELECTED_BENCHMARK_PROJECTS =
  'benchmarkReports/SET_SELECTED_BENCHMARK_PROJECTS';

export const GET_LOCATIONS_FOR_BENCHMARK_REPORTS =
  'benchmarkReports/GET_LOCATIONS_FOR_BENCHMARK_REPORTS ';
export const GET_LOCATIONS_FOR_BENCHMARK_REPORTS_SUCCEEDED =
  'benchmarkReports/GET_LOCATIONS_FOR_BENCHMARK_REPORTS_SUCCEEDED';

export const GET_BENCHMARK_PROJECTS_USF_RANGE =
  'benchmarkReports/GET_BENCHMARK_PROJECTS_USF_RANGE ';
export const GET_BENCHMARK_PROJECTS_USF_RANGE_SUCCEEDED =
  'benchmarkReports/GET_BENCHMARK_PROJECTS_USF_RANGE_SUCCEEDED';

export const GET_BENCHMARK_REPORT_PREVIEW =
  'benchmarkReports/GET_BENCHMARK_REPORT_PREVIEW ';
export const GET_BENCHMARK_REPORT_PREVIEW_SUCCEEDED =
  'benchmarkReports/GET_BENCHMARK_REPORT_PREVIEW_SUCCEEDED';
export const GET_BENCHMARK_REPORT_PREVIEW_FAILED =
  'benchmarkReports/GET_BENCHMARK_PROJECTS_FAILED';

export const REFRESH_SELECTED_BENCHMARK_PROJECTS =
  'benchmarkReports/REFRESH_SELECTED_BENCHMARK_PROJECTS ';
export const REFRESH_SELECTED_BENCHMARK_PROJECTS_SUCCEEDED =
  'benchmarkReports/REFRESH_SELECTED_BENCHMARK_PROJECTS_SUCCEEDED';

export const GET_CLIENTS_OF_BENCHMARK_PROJECTS =
  'benchmarkReports/GET_CLIENTS_OF_BENCHMARK_PROJECTS ';
export const GET_CLIENTS_OF_BENCHMARK_PROJECTS_SUCCEEDED =
  'benchmarkReports/GET_CLIENTS_OF_BENCHMARK_PROJECTS_SUCCEEDED';
export const GET_CLIENTS_OF_BENCHMARK_PROJECTS_FAILED =
  'benchmarkReports/GET_CLIENTS_OF_BENCHMARK_PROJECTS_FAILED';

export const CREATE_BENCHMARK_REPORT =
  'benchmarkReports/CREATE_BENCHMARK_REPORT ';
export const CREATE_BENCHMARK_REPORT_SUCCEEDED =
  'benchmarkReports/CREATE_BENCHMARK_REPORT_SUCCEEDED';
export const CREATE_BENCHMARK_REPORT_FAILED =
  'benchmarkReports/CREATE_BENCHMARK_REPORT_FAILED';

export const GET_BENCHMARK_REPORT = 'benchmarkReports/GET_BENCHMARK_REPORT';
export const GET_BENCHMARK_REPORT_SUCCEEDED =
  'benchmarkReports/GET_BENCHMARK_REPORT_SUCCEEDED';
export const GET_BENCHMARK_REPORT_FAILED =
  'benchmarkReports/GET_BENCHMARK_REPORT_FAILED';

export const CLEAN_UP_CURRENT_BENCHMARK_REPORT =
  'benchmarkReports/CLEAN_UP_CURRENT_BENCHMARK_REPORT';

export const GET_BENCHMARK_REPORTS = 'benchmarkReports/GET_BENCHMARK_REPORTS ';
export const GET_BENCHMARK_REPORTS_SUCCEEDED =
  'benchmarkReports/GET_BENCHMARK_REPORTS_SUCCEEDED';
export const GET_BENCHMARK_REPORTS_FAILED =
  'benchmarkReports/GET_BENCHMARK_REPORTS_FAILED';

export const GET_MISSING_DATA = 'benchmarkReports/GET_MISSING_DATA';
export const GET_MISSING_DATA_SUCCEEDED =
  'benchmarkReports/GET_MISSING_DATA_SUCCEEDED';
export const ADD_MISSING_FLOOR_DATA_FIELD =
  'benchmarkReports/ADD_MISSING_FLOOR_DATA_FIELD';
export const UPDATE_MISSING_FLOOR_DATA_FIELD =
  'benchmarkReports/UPDATE_MISSING_FLOOR_DATA_FIELD';
export const DELETE_MISSING_FLOOR_DATA_FIELD =
  'benchmarkReports/DELETE_MISSING_FLOOR_DATA_FIELD';
export const GET_MISSING_PROJECT_DATA =
  'benchmarkReports/GET_MISSING_PROJECT_DATA';
export const GET_MISSING_PROJECT_DATA_SUCCEEDED =
  'benchmarkReports/GET_MISSING_PROJECT_DATA_SUCCEEDED';

export const TOGGLE_BENCHMARK_REPORT_FROM_FAVORITES =
  'benchmarkReports/TOGGLE_BENCHMARK_REPORT_FROM_FAVORITES ';
export const TOGGLE_BENCHMARK_REPORT_FROM_FAVORITES_SUCCEEDED =
  'benchmarkReports/TOGGLE_BENCHMARK_REPORT_FROM_FAVORITES_SUCCEEDED';
export const TOGGLE_BENCHMARK_REPORT_FROM_FAVORITES_FAILED =
  'benchmarkReports/TOGGLE_BENCHMARK_REPORT_FROM_FAVORITES_FAILED';

export const SET_BENCHMARK_REPORTS = 'benchmarkReports/SET_BENCHMARK_REPORTS';

export const EDIT_BENCHMARK_REPORT = 'benchmarkReports/EDIT_BENCHMARK_REPORT ';
export const EDIT_BENCHMARK_REPORT_SUCCEEDED =
  'benchmarkReports/EDIT_BENCHMARK_REPORT_SUCCEEDED';
export const EDIT_BENCHMARK_REPORT_FAILED =
  'benchmarkReports/EDIT_BENCHMARK_REPORT_FAILED';

export const DELETE_BENCHMARK_REPORT =
  'benchmarkReports/DELETE_BENCHMARK_REPORT';

export const VERIFY_BENCHMARK_REPORT =
  'benchmarkReports/VERIFY_BENCHMARK_REPORT';
export const HIGHLIGHT_REPORT_ID = 'benchmarkReports/HIGHLIGHT_REPORT_ID';

export const SAVE_BENCHMARK_REPORT_CHANGES =
  'benchmarkReports/SAVE_BENCHMARK_REPORT_CHANGES';

export const SAVE_BENCHMARK_REPORT_CHANGES_SUCCEEDED =
  'benchmarkReports/SAVE_BENCHMARK_REPORT_CHANGES_SUCCEEDED';

export const ADD_BENCHMARK_REPORT_EDITORS =
  'benchmarkReports/ADD_BENCHMARK_REPORT_EDITORS';

export const ADD_BENCHMARK_REPORT_EDITORS_SUCCEEDED =
  'benchmarkReports/ADD_BENCHMARK_REPORT_EDITORS_SUCCEEDED';

export const GET_BENCHMARK_REPORT_EDITORS =
  'benchmarkReports/GET_BENCHMARK_REPORT_EDITORS';

export const GET_BENCHMARK_REPORT_EDITORS_SUCCEEDED =
  'benchmarkReports/GET_BENCHMARK_REPORT_EDITORS_SUCCEEDED';

export const REMOVE_BENCHMARK_REPORT_EDITOR =
  'benchmarkReports/REMOVE_BENCHMARK_REPORT_EDITOR';

export const REMOVE_BENCHMARK_REPORT_EDITOR_SUCCEEDED =
  'benchmarkReports/REMOVE_BENCHMARK_REPORT_EDITOR_SUCCEEDED';

export const TRANSFER_BENCHMARK_REPORT_OWNERSHIP =
  'benchmarkReports/TRANSFER_BENCHMARK_REPORT_OWNERSHIP';

export const TRANSFER_BENCHMARK_REPORT_OWNERSHIP_SUCCEEDED =
  'benchmarkReports/TRANSFER_BENCHMARK_REPORT_OWNERSHIP_SUCCEEDED';

export const GET_BENCHMARK_REPORT_FOR_EXPORTABLE =
  'benchmarkReports/GET_BENCHMARK_REPORT_FOR_EXPORTABLE';

export const GET_BENCHMARK_REPORT_FOR_EXPORTABLE_SUCCEEDED =
  'benchmarkReports/GET_BENCHMARK_REPORT_FOR_EXPORTABLE_SUCCEEDED';

export const UPDATE_BENCHMARK_REPORT_CATEGORIES =
  'benchmarkReports/UPDATE_BENCHMARK_REPORT_CATEGORIES';

export const UPDATE_BENCHMARK_REPORT_CATEGORIES_SUCCEEDED =
  'benchmarkReports/UPDATE_BENCHMARK_REPORT_CATEGORIES_SUCCEEDED';

export const SET_BENCHMARK_REPORT_CATEGORIES_MAP =
  'benchmarkReports/SET_BENCHMARK';

export const SET_BENCHMARK_REPORT_ICONS_MAP =
  'benchmarkReports/SET_BENCHMARK_REPORT_ICONS_MAP';

export const UPDATE_BENCHMARK_REPORT_ICONS =
  'benchmarkReports/UPDATE_BENCHMARK_REPORT_ICONS';

export const UPDATE_BENCHMARK_REPORT_ICONS_SUCCESS =
  'benchmarkReports/UPDATE_BENCHMARK_REPORT_ICONS_SUCCESS';

export const CLONE_BENCHMARK_REPORT = 'benchmarkReports/CLONE_BENCHMARK_REPORT';

export const DISMISS_BENCHMARK_ISSUES =
  'benchmarkReports/DISMISS_BENCHMARK_ISSUES';

export const DISMISS_BENCHMARK_ISSUES_SUCCESS =
  'benchmarkReports/DISMISS_BENCHMARK_ISSUES_SUCCESS';

export const getBenchmarkProjects = (filters: GetProjectsParams) =>
  createAction(GET_BENCHMARK_PROJECTS, filters);

export const getBenchmarkProjectsSucceeded = (projects: IProject[]) =>
  createAction(GET_BENCHMARK_PROJECTS_SUCCEEDED, projects);

export const getBenchmarkProjectsFailed = () =>
  createAction(GET_BENCHMARK_PROJECTS_FAILED);

export const getLocationsForBenchmarkProjects = () =>
  createAction(GET_LOCATIONS_FOR_BENCHMARK_REPORTS);

export const getLocationsForBenchmarkProjectsSucceeded = (
  projectsLocations: Address[]
) =>
  createAction(
    GET_LOCATIONS_FOR_BENCHMARK_REPORTS_SUCCEEDED,
    projectsLocations
  );

export const getUSFRangeOfBenchmarkProjects = () =>
  createAction(GET_BENCHMARK_PROJECTS_USF_RANGE);

export const getUSFRangeOfBenchmarkProjectsSucceeded = (projectsUSFRange: {
  min: number;
  max: number;
}) =>
  createAction(GET_BENCHMARK_PROJECTS_USF_RANGE_SUCCEEDED, projectsUSFRange);

export const setSelectedBenchmarkProjects = (
  benchmarkProjects: BenchmarkProject[]
) => createAction(SET_SELECTED_BENCHMARK_PROJECTS, benchmarkProjects);

export const getBenchmarkReportPreview = () =>
  createAction(GET_BENCHMARK_REPORT_PREVIEW);

export const getBenchmarkReportPreviewSucceeded = (
  summary: BenchmarkReportSummary
) => createAction(GET_BENCHMARK_REPORT_PREVIEW_SUCCEEDED, summary);

export const setBenchmarkReportCategoriesMap = (
  categoriesMap: BenchmarkReportCategoriesMap
) => createAction(SET_BENCHMARK_REPORT_CATEGORIES_MAP, categoriesMap);

export const setBenchmarkReportIconsMap = (iconsMap: BenchmarkReportIconsMap) =>
  createAction(SET_BENCHMARK_REPORT_ICONS_MAP, iconsMap);

export const updateBenchmarkReportIcons = (icons: BenchmarkReportIcon[]) =>
  createAction(UPDATE_BENCHMARK_REPORT_ICONS, icons);

export const updateBenchmarkReportIconsSucceeded = (
  icons: BenchmarkReportIcon[]
) => createAction(UPDATE_BENCHMARK_REPORT_ICONS_SUCCESS, icons);

export const getBenchmarkReportPreviewFailed = () =>
  createAction(GET_BENCHMARK_REPORT_PREVIEW_FAILED);

export const refreshSelectedBenchmarkProjects = () =>
  createAction(REFRESH_SELECTED_BENCHMARK_PROJECTS);

export const refreshSelectedBenchmarkProjectsSucceeded = (
  benchmarkProjects: BenchmarkProject[]
) =>
  createAction(
    REFRESH_SELECTED_BENCHMARK_PROJECTS_SUCCEEDED,
    benchmarkProjects
  );

export const getClientsOfBenchmarkProjects = () =>
  createAction(GET_CLIENTS_OF_BENCHMARK_PROJECTS);

export const getClientsOfBenchmarkProjectsSucceeded = (
  clients: ClientListItemVM[]
) => createAction(GET_CLIENTS_OF_BENCHMARK_PROJECTS_SUCCEEDED, clients);

export const getClientsOfBenchmarkProjectsFailed = () =>
  createAction(GET_CLIENTS_OF_BENCHMARK_PROJECTS_FAILED);

export const createBenchmarkReport = (params: {
  name: string;
  categories?: BenchmarkReportCategory[];
  icons?: BenchmarkReportIcon[];
  onSuccess: (report: BenchmarkReport) => void;
}) => createAction(CREATE_BENCHMARK_REPORT, params);

export const createBenchmarkReportSucceeded = () =>
  createAction(CREATE_BENCHMARK_REPORT_SUCCEEDED);

export const createBenchmarkReportFailed = () =>
  createAction(CREATE_BENCHMARK_REPORT_FAILED);

export const getBenchmarkReport = (id: number) =>
  createAction(GET_BENCHMARK_REPORT, id);

export const getBenchmarkReportSucceeded = (report: BenchmarkReport) =>
  createAction(GET_BENCHMARK_REPORT_SUCCEEDED, report);

export const getBenchmarkReportFailed = () =>
  createAction(GET_BENCHMARK_REPORT_FAILED);

export const getBenchmarkReports = (params: GetBenchmarkReportsParams) =>
  createAction(GET_BENCHMARK_REPORTS, params);

export const getBenchmarkReportsSucceeded = (
  paginatedReports: PaginatedBenchmarkReports
) => createAction(GET_BENCHMARK_REPORTS_SUCCEEDED, paginatedReports);

export const getBenchmarkReportsFailed = () =>
  createAction(GET_BENCHMARK_REPORTS_FAILED);

export const getMissingData = (projectId: number) =>
  createAction(GET_MISSING_DATA, projectId);

export const getMissingDataSucceeded = (missingData: MissingData) =>
  createAction(GET_MISSING_DATA_SUCCEEDED, missingData);

export const addMissingFloorDataField = (
  buildingId: number,
  floorId: number,
  missingDataField: MissingFloorDataField
) =>
  createAction(ADD_MISSING_FLOOR_DATA_FIELD, {
    buildingId,
    floorId,
    missingDataField,
  });

export const updateMissingFloorDataField = (
  buildingId: number,
  floorId: number,
  missingDataField: MissingFloorDataField
) =>
  createAction(UPDATE_MISSING_FLOOR_DATA_FIELD, {
    buildingId,
    floorId,
    missingDataField,
  });

export const deleteMissingFloorDataField = (
  buildingId: number,
  floorId: number,
  missingDataFieldId: number
) =>
  createAction(DELETE_MISSING_FLOOR_DATA_FIELD, {
    buildingId,
    floorId,
    missingDataFieldId,
  });

export const getMissingProjectData = (projectId: number) =>
  createAction(GET_MISSING_PROJECT_DATA, projectId);

export const getMissingProjectDataSucceeded = (
  missingProjectData: MissingProjectData
) => createAction(GET_MISSING_PROJECT_DATA_SUCCEEDED, missingProjectData);

export const toggleReportFromFavorites = (params: {
  reportId: number;
  isMarkedAsFavoriteByUser: boolean;
  onSuccess?: () => void;
}) => createAction(TOGGLE_BENCHMARK_REPORT_FROM_FAVORITES, params);

export const toggleReportFromFavoritesSucceeded = () =>
  createAction(TOGGLE_BENCHMARK_REPORT_FROM_FAVORITES_SUCCEEDED);

export const toggleReportFromFavoritesFailed = () =>
  createAction(TOGGLE_BENCHMARK_REPORT_FROM_FAVORITES_FAILED);

export const setBenchmarkReports = (reports: BenchmarkReport[]) =>
  createAction(SET_BENCHMARK_REPORTS, reports);

export const editBenchmarkReport = (report: Partial<BenchmarkReport>) =>
  createAction(EDIT_BENCHMARK_REPORT, report);

export const editBenchmarkReportSucceeded = (editedReport: BenchmarkReport) =>
  createAction(EDIT_BENCHMARK_REPORT_SUCCEEDED, editedReport);

export const editBenchmarkReportFailed = () =>
  createAction(EDIT_BENCHMARK_REPORT_FAILED);

export const deleteBenchmarkReport = (params: {
  reportId: number;
  onSuccess: () => void;
}) => createAction(DELETE_BENCHMARK_REPORT, params);

export const cleanUpCurrentBenchmarkReport = () =>
  createAction(CLEAN_UP_CURRENT_BENCHMARK_REPORT);

export const verifyBenchmarkReport = (params: { onSuccess: () => void }) =>
  createAction(VERIFY_BENCHMARK_REPORT, params);
export const highlightReportRow = (reportId: number) =>
  createAction(HIGHLIGHT_REPORT_ID, reportId);

export const saveBenchmarkReportChanges = (params: { onSuccess: () => void }) =>
  createAction(SAVE_BENCHMARK_REPORT_CHANGES, params);

export const saveBenchmarkReportChangesSucceeded = (
  updatedProjects: BenchmarkProject[]
) => createAction(SAVE_BENCHMARK_REPORT_CHANGES_SUCCEEDED, updatedProjects);

export const addBenchmarkReportEditors = (params: {
  onSuccess: () => void;
  usersIds: number[];
}) => createAction(ADD_BENCHMARK_REPORT_EDITORS, params);

export const addBenchmarkReportEditorsSucceeded = () =>
  createAction(ADD_BENCHMARK_REPORT_EDITORS_SUCCEEDED);

export const getBenchmarkReportEditors = (reportId: number) =>
  createAction(GET_BENCHMARK_REPORT_EDITORS, reportId);

export const getBenchmarkReportEditorsSucceeded = (
  editors: BenchmarkReportEditor[]
) => createAction(GET_BENCHMARK_REPORT_EDITORS_SUCCEEDED, editors);

export const removeBenchmarkReportEditor = (params: {
  onSuccess?: () => void;
  userId: number;
  reportId: number;
}) => createAction(REMOVE_BENCHMARK_REPORT_EDITOR, params);

export const removeBenchmarkReportEditorSucceeded = () =>
  createAction(REMOVE_BENCHMARK_REPORT_EDITOR_SUCCEEDED);

export const transferBenchmarkReportOwnership = (params: {
  onSuccess?: () => void;
  reportId: number;
  newOwnerId: number;
  shouldKeepOwnerAsEditor: boolean;
}) => createAction(TRANSFER_BENCHMARK_REPORT_OWNERSHIP, params);

export const transferBenchmarkReportOwnershipSucceeded = () =>
  createAction(TRANSFER_BENCHMARK_REPORT_OWNERSHIP_SUCCEEDED);

export const getBenchmarkReportForExportable = (params: {
  reportId: number;
  linkedProjectsIds: number[];
}) => createAction(GET_BENCHMARK_REPORT_FOR_EXPORTABLE, params);

export const getBenchmarkReportForExportableSucceded = (params: {
  report: BenchmarkReport;
  selectedProjects: BenchmarkProject[];
  reportSummary: BenchmarkReportSummary;
}) => createAction(GET_BENCHMARK_REPORT_FOR_EXPORTABLE_SUCCEEDED, params);

export const updateBenchmarkReportCategories = (params: {
  benchmarkReportCategories: BenchmarkReportCategory[];
  onSuccess?: () => void;
}) => createAction(UPDATE_BENCHMARK_REPORT_CATEGORIES, params);

export const updateBenchmarkReportCategoriesSucceded = (
  benchmarkReportCategories: BenchmarkReportCategory[]
) =>
  createAction(
    UPDATE_BENCHMARK_REPORT_CATEGORIES_SUCCEEDED,
    benchmarkReportCategories
  );

export const cloneBenchmarkReport = (params: {
  srcReportId: number;
  report: BenchmarkReport;
  onSuccess: () => void;
}) => createAction(CLONE_BENCHMARK_REPORT, params);

export const dismissBenchmarkIssues = (payload: {
  dismissedIssues: DismissedIssuesMap;
  projectId: number;
}) => createAction(DISMISS_BENCHMARK_ISSUES, payload);

export const dismissBenchmarkIssuesSucceded = (payload: MissingProjectData) =>
  createAction(DISMISS_BENCHMARK_ISSUES_SUCCESS, payload);

export const actions = {
  getBenchmarkProjects,
  getBenchmarkProjectsSucceeded,
  getBenchmarkProjectsFailed,
  setSelectedBenchmarkProjects,
  getLocationsForBenchmarkProjects,
  getLocationsForBenchmarkProjectsSucceeded,
  getUSFRangeOfBenchmarkProjects,
  getUSFRangeOfBenchmarkProjectsSucceeded,
  getBenchmarkReportPreview,
  getBenchmarkReportPreviewSucceeded,
  getBenchmarkReportPreviewFailed,
  refreshSelectedBenchmarkProjects,
  refreshSelectedBenchmarkProjectsSucceeded,
  getClientsOfBenchmarkProjects,
  getClientsOfBenchmarkProjectsSucceeded,
  getClientsOfBenchmarkProjectsFailed,
  createBenchmarkReport,
  createBenchmarkReportSucceeded,
  createBenchmarkReportFailed,
  getBenchmarkReport,
  getBenchmarkReportSucceeded,
  getBenchmarkReportFailed,
  getBenchmarkReports,
  getBenchmarkReportsSucceeded,
  getBenchmarkReportsFailed,
  getMissingData,
  getMissingDataSucceeded,
  addMissingFloorDataField,
  deleteMissingFloorDataField,
  getMissingProjectData,
  getMissingProjectDataSucceeded,
  toggleReportFromFavorites,
  toggleReportFromFavoritesSucceeded,
  toggleReportFromFavoritesFailed,
  setBenchmarkReports,
  editBenchmarkReport,
  editBenchmarkReportSucceeded,
  editBenchmarkReportFailed,
  deleteBenchmarkReport,
  cleanUpCurrentBenchmarkReport,
  verifyBenchmarkReport,
  highlightReportRow,
  saveBenchmarkReportChanges,
  saveBenchmarkReportChangesSucceeded,
  addBenchmarkReportEditors,
  addBenchmarkReportEditorsSucceeded,
  getBenchmarkReportEditors,
  getBenchmarkReportEditorsSucceeded,
  removeBenchmarkReportEditor,
  removeBenchmarkReportEditorSucceeded,
  transferBenchmarkReportOwnership,
  transferBenchmarkReportOwnershipSucceeded,
  getBenchmarkReportForExportable,
  getBenchmarkReportForExportableSucceded,
  updateBenchmarkReportCategories,
  updateBenchmarkReportCategoriesSucceded,
  updateBenchmarkReportIcons,
  updateBenchmarkReportIconsSucceeded,
  setBenchmarkReportCategoriesMap,
  setBenchmarkReportIconsMap,
  cloneBenchmarkReport,
  dismissBenchmarkIssues,
  dismissBenchmarkIssuesSucceded,
};

export type Actions = ActionsUnion<typeof actions>;
